import { render, staticRenderFns } from "./receiverJobStatistice.vue?vue&type=template&id=d75cc012&scoped=true"
import script from "./receiverJobStatistice.vue?vue&type=script&lang=js"
export * from "./receiverJobStatistice.vue?vue&type=script&lang=js"
import style0 from "./receiverJobStatistice.vue?vue&type=style&index=0&id=d75cc012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75cc012",
  null
  
)

export default component.exports